import React from 'react'
import { useNavigate } from 'react-router-dom'
import RoomForm from './RoomForm'
export default function BailleursNew(){
  const navigate = useNavigate()
  return (
    <section className="section">
      <div className="container mx-auto px-4 max-w-5xl">
        <RoomForm mode="create" onDone={()=>navigate('/bailleurs')} />
      </div>
    </section>
  )
}